/**
 * Make relative path absolute.
 * @param {String} path    The relative path.
 * @param {String} siteUrl The site base.
 * @returns {URL|string}
 */
export function toAbsolute(path, siteUrl) {
  // Make sure it's not already absolute.
  if (path && typeof path === 'string' && path.indexOf('http') === 0) {
    return path;
  }
  try {
    return new URL(path, siteUrl);
  } catch (e) {
    return path;
  }
}
